var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9725 4.21984C21.3958 3.12984 19.6025 3.12984 19.0258 4.21984L4.02582 32.5532C3.8913 32.8072 3.82476 33.0917 3.83266 33.379C3.84056 33.6663 3.92264 33.9467 4.07092 34.193C4.2192 34.4392 4.42863 34.6429 4.67889 34.7843C4.92915 34.9257 5.21172 34.9999 5.49915 34.9998H35.4992C35.7866 35.0004 36.0692 34.9265 36.3196 34.7854C36.57 34.6442 36.7795 34.4405 36.9277 34.1943C37.0759 33.948 37.1578 33.6676 37.1654 33.3803C37.1729 33.0929 37.1059 32.8086 36.9708 32.5548L21.9725 4.21984ZM22.1658 29.9998H18.8325V26.6665H22.1658V29.9998ZM18.8325 23.3332V14.9998H22.1658L22.1675 23.3332H18.8325Z",
    fill: "#FF1028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/IconError.dd1df19a03bbea1d7edf65a49b46543f.svg";
export { ForwardRef as ReactComponent };